import React from 'react'
import { Editor } from '@tiptap/core'
import { SlashDropdownMenuProps, SlashMenuConfig, SuggestionItem } from './types.js'
import { SuggestionMenu } from './SuggestionMenu.js'
import { SlashMenuList } from './SlashMenuList.js'
import { getSlashMenuItems, filterSuggestionItems } from './utils.js'

const defaultConfig: SlashMenuConfig = {
  enabledItems: [
    'text',
    'heading_1',
    'heading_2',
    'heading_3',
    'bullet_list',
    'ordered_list',
    'quote',
    'code_block',
    'image',
    'horizontal_rule',
    'button',
    'custom_html',
    'social',
    'columns',
    'unsubscribe_footer',
    'twitter',
    // 'ai_writer',
  ],
  showGroups: true,
  itemGroups: {
    text: 'Style',
    heading_1: 'Style',
    heading_2: 'Style',
    heading_3: 'Style',
    bullet_list: 'Lists',
    ordered_list: 'Lists',
    quote: 'Style',
    code_block: 'Style',
    image: 'Content',
    horizontal_rule: 'Content',
    button: 'Content',
    custom_html: 'Content',
    social: 'Content',
    columns: 'Layout',
    unsubscribe_footer: 'Content',
    twitter: 'Content',
    // ai_writer: 'AI',
  },
}

export const SlashDropdownMenu = ({ editor, config = defaultConfig }: SlashDropdownMenuProps) => {
  if (!editor) {
    return null
  }

  const mergedConfig = { ...defaultConfig, ...config }

  const getItems = ({ query, editor }: { query: string; editor: Editor }) => {
    const allItems = getSlashMenuItems(editor, mergedConfig)
    return filterSuggestionItems(allItems, query)
  }

  return (
    <SuggestionMenu editor={editor} char="/" items={getItems}>
      {(props: any) => (
        <SlashMenuList
          ref={props.ref}
          items={props.items}
          command={props.command}
          showGroups={mergedConfig.showGroups}
        />
      )}
    </SuggestionMenu>
  )
}
